import React, { useContext } from 'react'
import { LiabilitiesContext } from '../../context'
import { Grid } from '@components/layout/Grid'
import { Card, CardHeading, CardContent, CardFooter } from '@components/layout/Card'
import { PlusCircle } from '@components/Icons/PlusCircle'
import { Button } from '@components/Button'
import { humanizeString } from '@utils/stringMinipulation'

export const Create = () => {
  const {
    state: { supportedLiabilityTypes },
    actions: { setLiabilityTypeToCreate, goToIndex }
  } = useContext(LiabilitiesContext)

  return (
    <>
      <Grid className='grid--small-columns'>
        {supportedLiabilityTypes.map((liabilityType) =>
          <Card key={liabilityType} darkBorder className='ui-card--entity-types' onClick={setLiabilityTypeToCreate(liabilityType)}>
            <CardHeading>
              <h5>{humanizeString(liabilityType)}</h5>
            </CardHeading>
            <CardContent>
              <PlusCircle />
            </CardContent>
          </Card>
        )}
      </Grid>
      <CardFooter>
        <Button tertiary onClick={goToIndex}>Back</Button>
      </CardFooter>
    </>
  )
}
